import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../models/Analytics';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	showRequestInvitePopup?: boolean;
}

export class VulnerabilityDisclosure extends React.Component<IProps, IState> {
	public state: IState = {
		showRequestInvitePopup: false,
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Vulnerability Disclosure Program';
		logPageView('Vulnerability Disclosure');
	}

	public render() {
		return (
			<MainContainer>
				<div className='privacy-outerContainer'>
					<h1>Levitate Vulnerability Program Scope and Rules</h1>

					<h2>In Scope</h2>

					<p>
						We are primarily interested in vulnerabilities in the following categories:
					</p>
					<ul>
						<li>Sensitive Data Exposure – Cross Site Scripting (XSS) Stored, SQL Injection (SQLi), etc.</li>
						<li>Authentication or Session Management related issues</li>
						<li>Remote Code Execution</li>
						<li>Unique issues that do not fall into explicit categories</li>
					</ul>

					<h2>Out of Scope</h2>
					<p>
						The following vulnerability categories are considered out of scope of our responsible disclosure program and should be avoided by researchers.
					</p>

					<ul>
						<li>Denial of Service (DoS) – Either through network traffic, resources exhaustion or others</li>
						<li>Issues only present in old browsers/old plugins/end-of-life software browsers</li>
						<li>Phishing or social engineering of Real Magic / Levitate employees, users or clients</li>
						<li>Disclosure of known public files and other information disclosures that are not a material risk (e.g.: robots.txt)</li>
						<li>Any attack or vulnerability that hinges on a user's computer or email account first being compromised</li>
					</ul>

					<p>
						Please note that you are expected to engage in security research responsibly.
						For example, if you discover a publicly exposed password or key, you should not use the key to test
						the extent of access it grants or to download or exfiltrate data in order to prove it is an active key.
						Similarly, if you discover a successful SQL injection, you are expected not to exploit the vulnerability beyond any initial steps
						needed to demonstrate your proof-of-concept. Excessive exfiltration or downloading of Levitate data, or demanding payment in return
						for destruction of Levitate data, will be considered outside of the scope of this program, and Real Magic will reserve all of its rights,
						remedies, and actions to protect itself and its users.
					</p>

					<h2>Vulnerability Rewards</h2>
					<p>
						Our program does not currently provide any monetary rewards.
					</p>

					<h2>How to Report a Vulnerability</h2>
					<p>
						To report a vulnerability, please send an email to <a href='mailto:security@levitateapp.com'>security@levitateapp.com</a>.
					</p>
				</div>
			</MainContainer>
		);
	}
}
